import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { ROUTE_IDS } from "../i18n/routeIds";
import { PRODUCT_IDS } from "../i18n/productContext";
import { resolveRoutePath } from "../i18n/routeGuards";
import { normalizeLocale } from "../i18n/routeLocale";
import { useLocalePath } from "../contexts/LocalePathContext";
import { traceHotelProfileRoute } from "../i18n/routeTelemetry";

/**
 * Public locale-prefixed /en|el/hotelprofile/:id → agent dashboard profile route.
 */
export function HotelProfilePublicLegacyRedirect() {
  const { hotelid, hotelId: hotelIdParam } = useParams();
  const location = useLocation();
  const { localePrefix } = useLocalePath();
  const hotelId = hotelIdParam ?? hotelid;
  const locale = normalizeLocale(localePrefix === "el" ? "el" : "en");

  const resolved = resolveRoutePath(ROUTE_IDS.HOTEL_PROFILE, {
    locale,
    product: PRODUCT_IDS.AGENT,
    params: { hotelId, hotelid: hotelId },
  });

  traceHotelProfileRoute({
    fromPath: location.pathname,
    toPath: resolved?.path ?? null,
    locale,
    routeId: ROUTE_IDS.HOTEL_PROFILE,
    hotelId,
    reason: "public_legacy_redirect",
  });

  if (!resolved?.path) {
    return <Navigate to="/" replace />;
  }

  return (
    <Navigate
      to={`${resolved.path}${location.search}${location.hash}`}
      replace
    />
  );
}

export default HotelProfilePublicLegacyRedirect;
